import { render, staticRenderFns } from "./AgregarSubSeccionModal.vue?vue&type=template&id=424ca1f7"
import script from "./AgregarSubSeccionModal.vue?vue&type=script&lang=js"
export * from "./AgregarSubSeccionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports